import React, { useState, useEffect } from 'react';

import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import OutlinedInput from '@mui/material/OutlinedInput';

import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const supportedPeriods = [null, 'Y', 'M', 'D'];

const DurationPicker = ({ name, value, label, onChange, disabled, size, ...props }) => {
	const [internalValue, setInternalValue] = useState();
	const [period, setPeriod] = useState(null);

	const handleChange = (v, valuePeriod = period) => {
		if (supportedPeriods.includes(valuePeriod))
			setPeriod(valuePeriod);

		const valueInt = (parseInt(v || internalValue) || 1);
		const valueChecked = Math.max(valueInt, 0);
		setInternalValue(valuePeriod ? valueChecked : '');

		const durationString = valuePeriod ? `P${valueChecked}${valuePeriod}` : null;
		if (!onChange || value === durationString) return;
		onChange({ target: { name, value: durationString } });
	};

	const parseValue = (value) => {
		if (!value) return;
		const chars = value.match(/[A-Z]/g);
		const number = value.match(/[0-9]+/g);
		let v = 0;
		if (chars[0] !== 'P') {
			handleChange(0);
			return;
		}
		handleChange(number, chars[1]);
	};

	const minusOne = () => handleChange(internalValue - 1);
	const addOne = () => handleChange(internalValue + 1);

	useEffect(() => parseValue(value), [value]);


	return (
		<Box sx={{ display: 'flex' }}>
			<FormControl sx={{ flexGrow: 1 }}>
				{label && <InputLabel>{label}</InputLabel>}
				<OutlinedInput
					label={label}
					pattern='[0-9]*'
					onChange={({ target: { value } }) => handleChange(value)}
					value={internalValue || ''}
					inputProps={{
						sx: { marginLeft: 2 },
					}}
					disabled={disabled}
					placeholder='No time period selected'
					startAdornment={!disabled && period &&
						<InputAdornment position="start">
							<IconButton
								onClick={minusOne}
								edge="end"
							>
								<RemoveIcon />
							</IconButton>
						</InputAdornment>
					}
					endAdornment={!disabled && period &&
						<InputAdornment position="end">
							<IconButton
								onClick={addOne}
								edge="start"
							>
								<AddIcon />
							</IconButton>
						</InputAdornment>
					}
					size={size}
				/>
			</FormControl>
			<FormControl sx={{ marginLeft: 2, width: 140 }}>
				<Select
					variant='outlined'
					value={period || ''}
					onChange={({ target: { value } }) => handleChange(null, value)}
					disabled={disabled}
					size={size}
				>
					<MenuItem value={null}>-</MenuItem>
					<MenuItem value="Y">Year(s)</MenuItem>
					<MenuItem value="M">Month(s)</MenuItem>
					<MenuItem value="D">Day(s)</MenuItem>
				</Select>
			</FormControl>
		</Box>
	);
};

DurationPicker.type = 'DurationPicker';
DurationPicker.spec = [{
	name: 'DurationPicker',
	key: 'DurationPicker',
	category: 'input',
	title: 'Duration',
	icon: 'Calendar',
	translatable: ['label', 'placeholder'],
	fields: [{
		type: 'TextField',
		label: 'Label',
		name: 'label',
	}, {
		type: 'TextField',
		label: 'Placeholder',
		name: 'placeholder',
	}, {
		type: 'Checkbox',
		label: 'Required?',
		name: 'required',
	}],
}];

export default DurationPicker;
